/**
 * The Bianka event bus name to use when emitting/listening to Bianka events.
 * @type {string}
 */
export const BIANKA_EVENT_NAME = 'OBS::BIANKA';
